import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { Site } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createMutationCallbacks } from '@klareospace/pharos-lib-web-utils';

import { createSiteApi, siteKeys } from '../api';
import type { CreateSiteParams } from '../api';

export function useCreateSite(): UseMutationResult<Site, Error, CreateSiteParams> {
  const client = useApiClient('admin-auth');
  const api = createSiteApi(client);
  const queryClient = useQueryClient();

  return useMutation<Site, Error, CreateSiteParams>({
    mutationFn: (params: CreateSiteParams) => api.createSite(params),
    ...createMutationCallbacks({
      invalidateKeys: [siteKeys.all],
      queryClient,
    }),
  });
}
